import { useQuery } from '@tanstack/react-query'
import { pb } from '@/lib/pocketbase'

interface ReverseGeocodeResult {
    placeName: string
    address: string
}

interface UseReverseGeocodeOptions {
    latitude?: number
    longitude?: number
    enabled?: boolean
}

export function useReverseGeocode({
    latitude,
    longitude,
    enabled = true,
}: UseReverseGeocodeOptions) {
    return useQuery({
        queryKey: ['reverse-geocode', latitude, longitude],
        queryFn: async () => {
            const response = await fetch(
                `${pb.baseURL}/api/geocode?lat=${latitude}&lng=${longitude}`,
                {
                    headers: {
                        Authorization: pb.authStore.token,
                    },
                }
            )

            if (!response.ok) {
                const error = await response.json()
                throw new Error(error.message || 'Failed to reverse geocode')
            }

            return response.json() as Promise<ReverseGeocodeResult>
        },
        enabled: enabled && latitude != null && longitude != null,
        staleTime: Number.POSITIVE_INFINITY,
    })
}
